// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"28a877bd","239":"74deeb42","732":"dfeed64a"}[chunkId] + ".chunk.js";
};